import * as yup from 'yup';

export const taskTypeSchema = yup.object().shape({
  color_icon: yup.string().nullable().required('common.fieldRequired'),
  name: yup.string().required('common.fieldRequired'),
  execution_progress_tracking_id: yup.string().required('common.fieldRequired'),
  approvers_attributes: yup
    .array()
    .of(
      yup
        .object()
        .shape({ function_id: yup.number().required('common.fieldRequired') })
    )
});
